import { render } from "./ViewAddWorldCity.vue?vue&type=template&id=f9987d0a&scoped=true"
import script from "./ViewAddWorldCity.vue?vue&type=script&lang=js"
export * from "./ViewAddWorldCity.vue?vue&type=script&lang=js"

import "./ViewAddWorldCity.vue?vue&type=style&index=0&id=f9987d0a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9987d0a"]])

export default __exports__